<template>
  <router-view>
  </router-view>
</template>

<script>
  import Vue from 'vue';
  import constants from './_consts';
  import cssHelper from './utils/css-helper'
  // import Auth from '@aws-amplify/auth';

  export default {
    name: 'app',
    beforeMount () {
      cssHelper.customColorForUI();
      // before send request
      Vue.axios.interceptors.request.use((config) => {
        const token = localStorage.getItem(constants.LOCAL_STORE.token);
        if (token) {
          config.headers['Authorization'] = 'Bearer ' + token.replace('Bearer ', '');
          config.headers['Content-Type'] = 'application/json';
        }
        return config;
      }, (err) => {
        return Promise.reject(err);
      });
      // after receive response
      Vue.axios.interceptors.response.use((response) => {
        return response;
      }, (error) => {
        if (error.response && error.response.status === 401) {
          // remove all local storage
          localStorage.removeItem(constants.LOCAL_STORE.userId);
          localStorage.removeItem(constants.LOCAL_STORE.token);
          localStorage.removeItem(constants.LOCAL_STORE.role);
          // redirect to login
          this.$router.push('/login');

          //        console.log('this.$modal=', this.$modal);
          //        this.$modal.show('dialog', {
          //          title: globalMessage.dialog.unAuthorizedToken.title,
          //          text: globalMessage.dialog.unAuthorizedToken.msg,
          //          buttons: [
          //            { title: globalMessage.common.yes,
          //              handler: () => {
          //                this.$modal.hide('dialog');
          //                this.$router.push('/login');
          //              }
          //            }
          //          ]
          //        });
        } else {
          return Promise.reject(error);
        }
      });
    }
  };
</script>

<style lang="less">
  @import './styles/customstyle.less';
</style>



// WEBPACK FOOTER //
// App.vue?46cb425b